<script setup>
import {
    CollapsibleContent,
    CollapsibleRoot,
    CollapsibleTrigger,
} from 'reka-ui';

defineProps({
    /**
     * Initial open state when uncontrolled (no `v-model:open`).
     * Useful for letting a section start expanded based on the active route.
     * @default false
     */
    defaultOpen: {
        type: Boolean,
        default: false,
    },
    /**
     * When `true`, the trigger is non-interactive and the collapsible cannot be toggled.
     * @default false
     */
    disabled: {
        type: Boolean,
        default: false,
    },
});

const isOpen = defineModel('open', { type: Boolean, default: undefined });
</script>

<template>
    <CollapsibleRoot
        v-model:open="isOpen"
        :default-open="defaultOpen"
        :disabled="disabled"
    >
        <CollapsibleTrigger as-child>
            <slot
                name="trigger"
                :open="isOpen"
            />
        </CollapsibleTrigger>

        <CollapsibleContent>
            <slot :open="isOpen" />
        </CollapsibleContent>
    </CollapsibleRoot>
</template>
